<mat-card>
  <mat-card-header>
    <div class="header--container">
      <mat-icon>search</mat-icon>
      <input #searchInput type="text" placeholder="Type to search..." (input)="filterMenu(searchInput.value)" />
      <span>Esc</span>
    </div>
  </mat-card-header>

  <mat-card-content>
    <ul class="menu">
      <li *ngFor="let item of filteredMenu">
        <!-- Parent item -->
        <div class="menu-parent" [class.has-children]="item.subItems?.length" (click)="onParentClick(item)">
          # <span class="title">{{ item.title }}</span>

          <mat-icon *ngIf="item.subItems?.length" class="chevron">
            {{ item.isExpanded ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div>

        <!-- Children -->
        <ul *ngIf="item.subItems?.length && item.isExpanded" class="submenu">
          <li *ngFor="let sub of item.subItems" class="menu-child"
            (click)="navigate(sub.routerLink); $event.stopPropagation()">
            #{{ sub.title }}
          </li>
        </ul>
      </li>
    </ul>
    <div class="empty-state" *ngIf="!search">
      Start typing to search menus
    </div>

    <div class="empty-state" *ngIf="search && !filteredMenu.length">
      Nothing was found
    </div>
  </mat-card-content>
  <mat-card-footer>
    <button class="close" (click)="close()">Close</button>
    <span>Press escape(esc) button to close or click the "close" button.</span>
  </mat-card-footer>

</mat-card>